
/** URI encodes the passed in string, then replaces all % characters with $ characters */
export function escapeRqlValue(value: string): string {
    return encodeURIComponent(value).replace(
        /[-_.!~*'()\$]/g,
        c => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
    ).replace(/%/g, '$');
   
}


export function unescapeRQLValue(value: string) {
    return decodeURIComponent(value.replace(/\$/g, '%'));
}
